import { Header } from '../components/header/Header';
import AppRoutes from '../route/routes';
import '../styles/layout.scss';
import { useNavigationContext } from '../hooks/useNavigationContext';

export function Layout() {
  const { isBlocked, onBlockedNavigation } = useNavigationContext();

  return (
    <div className='container-page'>
      <Header title='' enableBack={false} isBlocked={isBlocked} onBlockedNavigation={onBlockedNavigation} />
      <main className='layoutBody'>{<AppRoutes />}</main>

    </div>
  );
}
